//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import HeaderCatalogerResource from '../../components/headerCatalogerResource/headerCatalogerResource'
import EditorPanelStimulus from '../../components/editorPanelStimulus/editorPanelStimulus'
import { Spinner } from 'react-bootstrap'
import AcademicComponentEditorComponent from 'app_components/modules/academicComponentEditor'
import { Redirect } from 'react-router-dom'
import ListQuestionsExerciseComponent from '../../components/listQuestionsExercise/containers/listQuestionsExerciseComponent'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
//@end

// @import hooks
import { useQuery } from 'app_hooks/useQuery'
// @end

// @INFO Import types
import {
  ICourseModeApi,
  IQuestionEditor,
  IQuestionEditorState,
  ISettingsTabsEditorAcademicComponent,
  TypeQuestionsCategoriesEditor
} from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions'
// @end

// @INFO Import services
import EditorService from 'app_services/editor/editorService'
import QuestionsService from 'app_services/editor/questions/questionsService'
import CatalogerService, { IExtradataUpdateResourceEditor } from 'app_services/editor/cataloger/catalogerService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import storeService from 'app_services/storeService'
import CourseModeService from 'app_services/campus/academic/courseModeService'
import CourseSchedulingModeMasterService from 'app_services/admin/courseScheduling/courseSchedulingModeMasterService'
import CourseSchedulingModeService from 'app_services/admin/courseScheduling/courseSchedulingModeService'
// @end

// @INFO Import Styles
import './../createsurveyScreen.scss'

// @ADD Component types
interface ICreatesurveyScreenLayoutProps {
  history?: any
}

interface IQuestionApi{
  position?: number
  question: string
  value: number
}

const CreatesurveyScreenLayout: React.FC<ICreatesurveyScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  const [editState, updateEditState] = useState(true)
  const [loading, updateLoading] = useState(false)
  const [loadingFirst, updateLoadingFirst] = useState(true)
  var [responseAPI, updateResponseAPI] = useState<undefined | any>(undefined)
  const [urlReturn, updateUrlReturn] = useState<undefined | string>(undefined)
  const [currentQuestion, updateCurrentQuestion] = useState<IQuestionEditorState | IQuestionEditor | undefined>(undefined)
  const [temporalQuestionId, updateTemporalQuestionId] = useState<string | undefined>(undefined)
  const [temporalQuestions, updateTemporalQuestions] = useState<IQuestionEditorState[] | IQuestionEditor[] | undefined>(undefined)
  const [triggerNewStimulus, updateTriggerNewStimulus] = useState<any | undefined>(undefined)
  const [triggerReorder, updateTriggerReorder] = useState<IQuestionApi[] | undefined>(undefined)
  const [titleResource, updateTitleResource] = useState<string>('')
  const [openPanel, updateOpenPanel] = useState<boolean>(true)
  const [triggerSettings, updateTriggerSettings] = useState<any | undefined>(undefined)
  const [listOfCourseModes, updateListOfCourseModes] = useState<ICourseModeApi[]>([])
  const [isCharacterizationSurvey, setIsCharacterizationSurvey] = useState<boolean>(false)

  // @INFO Configuración de los tabs
  const [settingTab, updateSettingTab] = useState<ISettingsTabsEditorAcademicComponent>({tabs: []})
  // @INFO Obtener parámetros de URL
  const {query} = useQuery()

  // Servicios
  const editorService = new EditorService()
  const questionService = new QuestionsService()
  const catalogerService = new CatalogerService()
  const screenNotification = new ScreenNotificationsUtil()
  const courseSchedulingModeService: CourseSchedulingModeService = new CourseSchedulingModeService()

  // Obtener la data del recurso
  useEffect(() => {
    const getAll = async () => {
        updateLoading(true)
        // @INFO Obtener los componentes académicos a relacionar
        const courseModes = await getCourseModes()
        await getDataResource({ courseModes: courseModes })
        updateLoading(false)
    }
    getAll()
  }, [])

  // Trigger de nuevo estimulo
  useEffect(() => {
    if(triggerNewStimulus !== undefined){
        handleCloseNewQuestion(triggerNewStimulus)
        updateTriggerNewStimulus(undefined)
    }
  }, [triggerNewStimulus])

  // Trigger de reordenar
  useEffect(() => {
      const reorderFinish = async () => {
          if(triggerReorder !== undefined){
              const response = await updateQuestions(triggerReorder)
              if(response && response.code === 200){
                  // Obtengo la data del recurso
                  await getDataResource({newQuestionId: currentQuestion?.question?._id})
              }
          }
      }
      if(triggerReorder !== undefined){
          reorderFinish()
          updateTriggerReorder(undefined)
      }
  }, [triggerReorder])

  // @INFO Actualizar el panel
  useEffect(() => {
    if(triggerSettings){
      setSettingPanel(triggerSettings)
      updateTriggerSettings(undefined)
    }
  }, [triggerSettings])

  useEffect(() => {
    if(responseAPI){
      setSettingPanel()
    }
  },[currentQuestion])

  useEffect(() => {
      questionService.updateStatusChanged(false)
  }, [editState])

  /**
   * @INFO Obtener lista de modalidades los cursos
   */
  const getCourseModes = async () => {
    let types: Array<any> = []
    const response = await courseSchedulingModeService.list({moodle_id: true})
    if (response?.courseSchedulingModes) {
      response?.courseSchedulingModes.map((item: any) => {
        types.push({ _id: item._id, name: item.name })
      })
    }
    updateListOfCourseModes(types)
    return types
  }

  /**
   * @INFO Obtener la data de un recurso y actualizar los tabs
   */
  const getDataResource = async (options?: {newQuestionId?: string, courseModes?: ICourseModeApi[]}) => {
    const response: any = await catalogerService.getResourceData(query)
    updateLoadingFirst(false)
    if(response.code === 200){
        updateResponseAPI(response.academicResourceData)
        setSettingPanel(response.academicResourceData, options?.newQuestionId, { courseModes: options?.courseModes })
        return response.academicResourceData
    }else{
        updateResponseAPI(undefined)
        return undefined
    }
  }

  /**
   * @INFO Stream del cambio en el tal general
   * @param json
   */
  const streamGeneralTab = (json: any) => {
    updateTitleResource(json.name)
  }

  /**
   * @INFO Organizar la configuración del panel con la respuesta
   */
  const setSettingPanel = (data?: any, newQuestionId?: string, _options?: {courseModes?: ICourseModeApi[]}) => {
    let aux: any
    // Configurar modalidad
    const _courseModes = _options?.courseModes ? _options.courseModes : listOfCourseModes
    // Configurar data
    if(data){
      aux = {...data}
    }else{
        aux = {...responseAPI}
    }
    if(!aux) return

    // @INFO Configurar current question
    let auxCurrentQuestion: IQuestionEditorState | IQuestionEditor | undefined = currentQuestion ? {...currentQuestion} : undefined
    if(newQuestionId){
      // @INFO Encontrar la pregunta para asignarla como current question
      const question = aux.config.questions.reduce((acum: any, item: any) => {
        if(item.question._id === newQuestionId){
            acum = {...item}
        }else{
            if(item.childs){
                item.childs.forEach((child: any) => {
                    if(child.question._id === newQuestionId){
                        acum = {...child}
                    }
                })
            }
        }
        return acum
      }, undefined)
      updateCurrentQuestion({...question})
      auxCurrentQuestion = {...question}
    }


    const config: ISettingsTabsEditorAcademicComponent = {
        tabs: []
    }
    config.tabs.push({
        type: 'general',
        callback: ()=>{},
        streamCallback: streamGeneralTab,
        hideSaveButton: true,
        default: true,
        fields: catalogerService.getFieldsGeneral(query, aux),
    })
    config.tabs.push({
      type: 'advanced',
      callback: ()=>{},
      hideSaveButton: true,
      showExerciseEnded: true,
      courseModes: _courseModes,
      fields: catalogerService.getPossibleLaunchConfigFields(aux.possible_launch_config, aux?.launch_config, aux?.default_modules_config),
    })
    updateSettingTab({...config})
    // Actualizar el nombre del recurso
    updateTitleResource(aux.name)
  }

  /**
   * @INFO Actualizar el recurso academico
   */
  const updateResourceData = async (extradata?: IExtradataUpdateResourceEditor) => {
    const dataAcademicResource: any = {
      config: {
          duration: extradata?.duration ? extradata.duration : undefined
      },
    }
    if(temporalQuestions){
      // @ts-ignore
      const questionsApi = getQuestionsAPI(temporalQuestions).questionsApi
      dataAcademicResource.config.questions = questionsApi
    }
    const response = await catalogerService.updateAcademicResource(
      dataAcademicResource,
      'survey',
      responseAPI.academic_resource,
      {
        responseApi: {...responseAPI},
        showAlert: extradata?.showAlert
      }
    )
    return response
  }

  /**
   * @INFO Referencia de click en guardar todo
   * @param json
   */
  const handleClickSaveAll = async (json: any) => {
    updateLoading(true)
    let response: any
    // Actualizar recurso académico
    response = await updateResourceData({
      duration: json.general.duration,
    })
    // Actualizar configuración del recurso académico
    const dataAcademicResourceConfig = {
        academic_resource: responseAPI.academic_resource,
        source: {
            config_category: responseAPI.academic_resource_config_category
        },
        config: {
            ...json.advanced
        }
    }
    // console.log(dataAcademicResourceConfig);
    response = await editorService.updateAcademicResourceSetting(
        responseAPI.academic_resource_config,
        dataAcademicResourceConfig
    )
    // Actualizar contenedor del recurso
    response = await catalogerService.updateResourceContainer(query, json.general)
    if(response.code === 200){
        response = await catalogerService.getResourceData(query)
        if(response.code === 200){
            // updateEditState(false)
            updateResponseAPI(response.academicResourceData)
            setSettingPanel(response.academicResourceData)
        }
        catalogerService.showAlertSuccess(true)
    }else{
      catalogerService.showAlertError(true)
    }
    updateLoading(false)
  }

  /**
   * @INFO Cambiar la pregunta a editar
   * @param question
   */
  const handleClickQuestion = (question: any) => {
      updateCurrentQuestion({...question})
  }

  /**
   * @INFO Guardar recurso y regresar a la pantalla de unidades
   */
  const handleClickFinish = async () => {
    updateLoading(true)
    // Actualizo el recurso
    const response = await updateResourceData({
      showAlert: true
    })
    if(response?.code === 200){
      setTimeout(() => {
        // Retorno a la pantalla de unidades
        props.history.push(catalogerService.getUrlReturn())
      }, 1500)
    }
    updateLoading(false)
  }

  /**
   * @INFO Referencia de cancelar la edición del recurso
   */
  const handleClickCancelEdit = () => {
    updateUrlReturn(catalogerService.getUrlReturn(query))
  }

  /**
   * @INFO Referencia de pregunta guardada
   * @param status
   */
  const handleQuestionSaved = async (status?: boolean, _question?: IQuestionEditorState) => {
    if(status && currentQuestion){
        let auxQuestion = {...currentQuestion}
        const id = auxQuestion.question._id
        // Obtengo la data del recurso
        const response = await getDataResource()
        // Actualizar la pregunta seleccionada
        if(response){
            updateTemporalQuestionId(id)
            const idxReplaceQuestion = response.config.questions.findIndex((item: any) => item.question._id === auxQuestion.question._id)
            if(idxReplaceQuestion >= 0){
                updateCurrentQuestion( {...auxQuestion ,...response.config.questions[idxReplaceQuestion]})
            }
        }
        screenNotification.fireToast({message:  t('editor.resources.exercise.question_save_success')}, {position: 'top'})
    }
    questionService.updateStatusChanged(false)
  }

  /**
   * @INFO Referencia para eliminar pregunta del recurso
   */
  const handleDeleteQuestion = async (questionDelete?: IQuestionEditorState) => {
    // Encontrar el indice de la pregunta
    if(questionDelete){
        const questionsAPI = getQuestionsAPI().questionsApi
        // Encuentro la pregunta
        const idxQuestion = questionsAPI.findIndex(item => item.question === questionDelete.question._id)
        if(idxQuestion >= 0){
            questionsAPI.splice(idxQuestion, 1)
            let response = await updateQuestions(questionsAPI)
            if(response.code === 200){
              // Obtengo la data del recurso
              response = await getDataResource()
              if(questionDelete.question.parent && currentQuestion){
                // Actualizo el parent
                const auxQuestion = {...currentQuestion}
                const idxReplaceQuestion = response.config.questions.findIndex((item: any) => item.question._id === auxQuestion.question._id)
                if(idxReplaceQuestion >= 0){
                    updateCurrentQuestion( {...auxQuestion ,...response.config.questions[idxReplaceQuestion]})
                }
              }else{
                updateCurrentQuestion(undefined)
              }
              questionService.updateStatusChanged(false)
            }
        }
    }
  }

  /**
   * @INFO Referencia de cerrar nueva pregunta
   */
  const handleCloseNewQuestion = async (data? :any) => {
    if(data){
      // Actualizar el recurso académico con la nueva pregunta si no tiene parent
      let aux = {...responseAPI}
      const questions = [...aux.config.questions]
      const respQuestionsAPI = getQuestionsAPI()
      const questionsApi = respQuestionsAPI.questionsApi
      const positionQuestion = respQuestionsAPI.position
      questionsApi.push({position: positionQuestion, question: data.id, value: 1})
      // questionsApi.push({position: (questions.length+1), question: data.id})
      let response = await updateQuestions(questionsApi)
      if(response && response.code === 200){
          // Obtengo la data del recurso
          response = await getDataResource({
            newQuestionId: data.parent ? undefined : data.id
          })
          // Si tiene un parent actualizo la pregunta actual
          if(data.parent && currentQuestion){
            const auxQuestion = {...currentQuestion}
            const idxReplaceQuestion = response.config.questions.findIndex((item: any) => item.question._id === auxQuestion.question._id)
            if(idxReplaceQuestion >= 0){
                updateCurrentQuestion( {...auxQuestion ,...response.config.questions[idxReplaceQuestion]})
            }
          }
      }
    }
  }

  /**
   * @INFO Organizar las preguntas para enviar al API
   */
  const getQuestionsAPI = (data?: IQuestionEditorState[]) => {
    let questions: IQuestionEditor[] = []
    if(data && data.length){
        questions = [...data]
    }else{
        const aux = {...responseAPI}
        questions = [...aux.config.questions]
    }
    let position: number = 1
    const questionsApi = questions.reduce((acum: IQuestionApi[], item, idx) => {
        if(item.question.question_category.name !== 'container'){
            acum.push({position, question: item.question._id, value: item.value})
            position += 1
        }else{
            acum.push({question: item.question._id, value: item.value})
            if(item.childs){
                item.childs.forEach(child => {
                    acum.push({position, question: child.question._id, value: child.value})
                    position += 1
                })
            }
        }
        return acum
    },[])
    return {questionsApi, position}
  }

  /**
   * @INFO Actualizar preguntas
   * @param questionsApi
   */
  const updateQuestions = async (questionsApi: IQuestionApi[]) => {
    const response = await editorService.updateAcademicResource(
        storeService?.getAcademicResourceCategoryFromName('survey') as string,
        responseAPI.academic_resource,
        {
            config: {
                questions: questionsApi
            }
        }
    )
    return response
  }

  /**
   * @INFO Finaliza reordenar preguntas de un estimulo
   * @param question
   */
  const handleReorderStimulusFinish = (_question?: IQuestionEditorState) => {
    const auxQuestions = [...responseAPI.config.questions]
    if(auxQuestions && _question){
      // Encontrar la pregunta
      const idxQuestion = auxQuestions.findIndex(item => item.question._id === _question.question._id)
      if(idxQuestion >= 0){
        auxQuestions[idxQuestion] = {..._question}
        handleReorderFinish([...auxQuestions])
      }
    }
  }

  /**
   * @INFO Referencia para finalizar de reordenar
   * @param questions
   */
  const handleReorderFinish = (questions: any[]) => {
    const questionsApi = getQuestionsAPI(questions).questionsApi
    updateTriggerReorder(questionsApi)
  }

  /**
   * @INFO Finalizar edición de una pregunta
   */
  const handleClickFinishQuestion = async () => {
    const status = await questionService.validateChangeQuestion()
    if(status){
      updateCurrentQuestion(undefined)
    }
  }

  /**
   * @INFO Referencia para crear nueva pregunta
   * @param parent
   */
  const handleClickNewQuestion = async (parent?: string, type?: TypeQuestionsCategoriesEditor) => {
    if(type && type === 'container'){
        const response = await questionService.createQuestion({
            content: 'Sin titulo',
            question_category: storeService?.getQuestionCategoryFromName('container') as string
        })
        if(response.code === 200){
            updateTriggerNewStimulus(response.question)
        }
    }else{
        // if(!type){
        //     if(parent){
        //         updateInputDataModal({
        //             parent
        //         })
        //     }else{
        //         updateInputDataModal({})
        //     }
        //     updateOpenNewQuestion(true)
        // }
    }
  }

  return(
    <AppContainer>
      <div className='create_survey_screen-layout'>
        {loading && loadingFirst === false
        ?
            <div className='container-loading'>
                <Spinner animation="border" className='icon-loading' />
            </div>
        :null}
        <AcademicComponentEditorComponent
            open={true}
            onClickOpenPanel={()=>updateOpenPanel(!openPanel)}
            handleClose={()=>updateOpenPanel(!openPanel)}
            settings={settingTab}
            hideClose={true}
            disableAll={!editState}
            showSaveAll={true}
            onClickSaveAll={handleClickSaveAll}
            disableButtonSaveAll={loading}
            currentQuestion={currentQuestion}
            setIsCharacterizationSurvey={setIsCharacterizationSurvey}
        >
            <div className="container-page">
                <HeaderCatalogerResource
                  onClickFinish={handleClickFinish}
                  onClickCancel={handleClickCancelEdit}
                  hideCancelButton={currentQuestion ? true : false}
                  hideFinishButton={currentQuestion ? true : false}
                  // showQuestionNavigator={currentQuestion ? true : false}
                  // questions={responseAPI?.config?.questions}
                  // currentQuestion={currentQuestion}
                  title={titleResource}
                  // onChangeQuestion={handleClickQuestion}
                />
                {currentQuestion ?
                  currentQuestion.question.question_category.name === 'container' ||
                  currentQuestion.question.parent ?
                    <EditorPanelStimulus
                      disableAll={!questionService.validateEditPermission(currentQuestion.question)}
                      hideEditButton={!questionService.validateEditPermission(currentQuestion.question)}
                      showDeleteButton={!questionService.validateEditPermission(currentQuestion.question)}
                      isCharacterizationSurvey={isCharacterizationSurvey}
                      question={
                        questionService.getParentFromChild(responseAPI.config.questions, currentQuestion as IQuestionEditorState) as IQuestionEditorState
                      }
                      childs={
                        questionService.getChildsParentFromAnyQuestion(responseAPI.config.questions, currentQuestion as IQuestionEditorState)
                      }
                      currentQuestion={currentQuestion as IQuestionEditorState}
                      onQuestionSaved={handleQuestionSaved}
                      onNewQuestion={handleCloseNewQuestion}
                      onClickDelete={(question)=>handleDeleteQuestion(question as IQuestionEditorState)}
                      onReorderFinish={handleReorderStimulusFinish}
                      onClickFinish={handleClickFinishQuestion}
                      onChangeCurrentQuestion={handleClickQuestion}
                    />
                  :
                    // <EditorPanelExerciseEditorComponent
                    //     editState={
                    //       // editState ||
                    //       questionService.validateEditPermission(currentQuestion.question)
                    //     }
                    //     // loading={false}
                    //     // tags={tags}
                    //     // metadata={metadata}
                    //     hideEditButton={!questionService.validateEditPermission(currentQuestion.question)}
                    //     showDeleteButton={!questionService.validateEditPermission(currentQuestion.question)}
                    //     hideAddButton
                    //     question={currentQuestion as IQuestionEditorState}
                    //     onQuestionSaved={handleQuestionSaved}
                    //     onChangeQuestion={()=>questionService.updateStatusChanged(true)}
                    //     onClickDelete={(question)=>handleDeleteQuestion(question as IQuestionEditorState)}
                    //     onClickFinish={handleClickFinishQuestion}
                    //     onClickView={(itemView) => catalogerService.previewQuestion(itemView.question._id)}
                    // />
                    null
                :
                    responseAPI &&
                    responseAPI.config &&
                    responseAPI.config.questions &&
                    responseAPI.config.questions.length
                ?
                    <>
                        <p className='title-section' >{t('editor.resources.exercise.questions_stimulus')}</p>
                        <ListQuestionsExerciseComponent
                            questions={responseAPI.config.questions}
                            editState={editState}
                            // showStats
                            hideNewQuestion
                            onClickDelete={(question)=>handleDeleteQuestion(question as IQuestionEditorState)}
                            onReorderQuestions={handleReorderFinish}
                            // onClickNewQuestion={(parent)=>handleClickNewQuestion(parent)}
                            onChangeQuestions={(questions)=>updateTemporalQuestions(questions)}
                            onClickEdit={handleClickQuestion}
                            onClickQuestion={handleClickQuestion}
                        />
                        <ButtonComponent
                          variant='primary'
                          onClick={()=>handleClickNewQuestion(undefined, 'container')}
                        >
                          Nueva sección
                        </ButtonComponent>
                        {/* <GroupAddQuestionButton
                          buttonClassName='add-more-questions'
                          onClickNewQuestion={()=>handleClickNewQuestion()}
                          onClickNewStimulus={()=>handleClickNewQuestion(undefined, 'container')}
                          onClickSearchQuestion={()=>updateOpenSearchQuestions(true)}
                        /> */}
                    </>
                :
                  // <GroupAddQuestionButton
                  //   onClickNewQuestion={()=>handleClickNewQuestion()}
                  //   onClickNewStimulus={()=>handleClickNewQuestion(undefined, 'container')}
                  //   onClickSearchQuestion={()=>updateOpenSearchQuestions(true)}

                  // />
                  <ButtonComponent
                    variant='primary'
                    onClick={()=>handleClickNewQuestion(undefined, 'container')}
                  >
                    Nueva sección
                  </ButtonComponent>
                }

            </div>
            {urlReturn ? <Redirect to={urlReturn} /> : null}
        </AcademicComponentEditorComponent>
      </div>
    </AppContainer>
  )
}

export default CreatesurveyScreenLayout
